(function (window, $j) {
    //Top Navigation Dropdowns on Header
    $j('nav>ul>li:not(.nav-book-link)').hover(function () {
        $j(this).addClass('active');
        $j(this).children().first().attr("aria-expanded", "true");
    },
    function () {
        $j(this).removeClass('active');
        $j(this).children().first().attr("aria-expanded", "false");
        });

    $j('nav>ul>li:not(.nav-book-link)').click(function (e) {       
        if ($j(this).hasClass("active")) {
            $j(this).removeClass('active');
            $j(this).children().first().attr("aria-expanded", "false");
        }
        else {
            $j(this).addClass('active');
            $j(this).children().first().attr("aria-expanded", "true");
        }
    });

    $j(".navbar-toggle").on("touchstart", function (e) {
        e.stopPropagation();
    });
    function addMarginOnAlert() {
        if ($j(".security-alert").length > 0) {
            $j(".hero").css("margin-top", "138px");
        }
    }

    $j(document).ready(function () {
        addMarginOnAlert();
        $j(window).on("resize", function () {
            if (screen.width > 991) {
                if ($j(".security-alert").is(":visible")) {
                    addMarginOnAlert();
                } else {
                    $j(".hero").css("margin-top", "103px");
                }
            }
            else if (screen.width <= 991 && screen.width >= 768) {
                if ($j(".security-alert").is(":visible")) {
                    $j(".hero").css("margin-top", "98px");
                } else {
                    $j(".hero").css("margin-top", "63px");
                }
            }
            else if (screen.width <= 767 && screen.width >= 550) {
                $j(".hero").css("margin-top", "139px");
                $j(".hero.hotel, .hero.resort").css("margin-top", "63px");
            }
            else if (screen.width < 550) {
                $j(".hero").css("margin-top", "125px");
                $j(".hero.hotel, .hero.resort").css("margin-top", "49px");
            }
        });
    });
})(window, $j);